import { BehaviorSubject, Subject } from "rxjs";
import { injectable, singleton } from "tsyringe";
import { ExtensionContext } from "../../common/models/extension-config";
import { Module } from "../../common/module";

@singleton()
export class RequestInterceptorModule extends Module {
    public name: string = 'RequestInterceptorModule';
    public acceptedLicenseFlags: string[] = [];
    public shouldRun(context: ExtensionContext): boolean { return false; }
    public onTableauRequest = new Subject<{request: XMLHttpRequest, dataString: string | undefined, dataObject: any | undefined}>();
    constructor() {
        super([]);
    }
    public async run(): Promise<void> {
        const log = this.log;
        (function (send) {
            XMLHttpRequest.prototype.send = function (data) {
                const module: RequestInterceptorModule | undefined = window.stm.modules['RequestInterceptorModule'] as RequestInterceptorModule;
                if (module) {
                    const dataString = typeof data === "string" ? data as string : undefined;
                    let dataObject: any = undefined;
                    if (!!dataString) {
                        const trimmed = dataString.trim();
                        if ((trimmed.startsWith("{") && trimmed.endsWith("}")) || (trimmed.startsWith("[") && trimmed.endsWith("]"))) {
                            try {
                                dataObject = JSON.parse(dataString);
                            } catch (e) { }
                        }
                    }
                    module.onTableauRequest.next({ request: this, dataString, dataObject  });
                } else {
                    log.w("WARNING: RequestInterceptor module cannot intercept request, because it is not initialized yet");
                }
                send.call(this, data);
            };
        })(XMLHttpRequest.prototype.send);
      

    }

}